import React from 'react';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormPreloader,
  FormTitle,
  Label,
  RegularField,
  Text,
  TextAreaField,
  useFormContext,
} from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import { FieldLevelAccessBasicProperties } from '@/modules/role/role.types';

interface Props {
  isEditMode?: boolean;
  isLoading?: boolean;
  isModalMode?: boolean;
  defaultValues?: Partial<FieldLevelAccessBasicProperties>;
}
const BasicProperties: React.FC<Props> = ({
  isEditMode,
  defaultValues,
  isLoading,
  isModalMode,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<FieldLevelAccessBasicProperties>();
  return (
    <Box round="container1Round" background="canvas" pad="l" border={{ size: 'small', color: 'border1' }}>
      <FormTitle>Basic Properties</FormTitle>
      {isLoading ? (
        <FormPreloader testId="preloader" count={4} />
      ) : (
        <Box direction="column">
          <FieldWrapper margin={{ bottom: !isEditMode ? '' : 'm', top: isModalMode ? '' : 'm' }}>
            <Label
              showRequireIcon={isEditMode}
              name="fieldLevelAccessName"
              isNarrow={isModalMode}
            >
              Name
            </Label>
            {isEditMode ? (
              <ControllerWrapper errorText={errors?.name?.message}>
                <Controller
                  name="name"
                  control={control}
                  render={({ field }) => (
                    <Box width={{ max: 'medium' }}>
                      <RegularField
                        testId="field-level-access-name"
                        editMode={isEditMode}
                        placeholder="Name"
                        isError={!!errors?.name?.message}
                        onChange={field.onChange}
                        value={field.value}
                        name={field.name}
                      />
                    </Box>
                  )}
                />
              </ControllerWrapper>
            ) : (
              <Text data-testid={`field-level-access-name"_${defaultValues?.name}`}>
                {defaultValues?.name || EMPTY_FIELD_VALUE}
              </Text>
            )}
          </FieldWrapper>

          <FieldWrapper margin={{ bottom: !isEditMode ? '' : 'm' }}>
            <Label name="roleName" isNarrow={isModalMode}>
              Description
            </Label>
            {isEditMode ? (
              <Controller
                name="description"
                control={control}
                render={({ field }) => (
                  <Box width={{ max: 'medium', width: 'medium' }} direction="column">
                    <TextAreaField
                      data-testid="field-level-access-name_description_input"
                      value={field.value}
                      onChangeValue={field.onChange}
                      placeholder="Description"
                    />
                  </Box>
                )}
              />
            ) : (
              <Text size="medium" weight={400} data-testid="field-level-access-name_description">
                {defaultValues?.description || EMPTY_FIELD_VALUE}
              </Text>
            )}
          </FieldWrapper>
        </Box>
      )}
    </Box>
  );
};

export default BasicProperties;
